import { render, staticRenderFns } from "./DoubbleBtn.vue?vue&type=template&id=651e6893&scoped=true"
import script from "./DoubbleBtn.vue?vue&type=script&lang=js"
export * from "./DoubbleBtn.vue?vue&type=script&lang=js"
import style0 from "./DoubbleBtn.vue?vue&type=style&index=0&id=651e6893&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "651e6893",
  null
  
)

export default component.exports